<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/')"></span>
    </div>
    <div class="title">欢迎加入到家</div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'> -->
    <br>
    <div class="main">
      <div class="btn-long btn2" @click="goto('/service/form/joinus')">
        <div>团队加盟、商家合作<br><span class="btn-intro">一起开拓澳洲华人服务行业</span></div>
      </div>

      <div class="btn-long btn1 " @click="goto('/service/form/recruit')">
        <div>岗位招聘<br><span class="btn-intro">充满机遇的工作，留给爱挑战的你</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      order:{
        service:'move',
        data:{
          move_scale: "",
          move_valuables: [],
          pathway_address:[],
          move_car: "",
          move_out_name: "",
          move_out_phone: "",
          move_out_street: "",
          move_out_suburb: "",
          move_out_state: "NSW",
          move_out_postcode: "",
          move_out_floor: "",
          move_out_parking: "",
          move_in_name: "",
          move_in_phone: "",
          move_in_street: "",
          move_in_suburb: "",
          move_in_state: "NSW",
          move_in_postcode: "",
          move_in_floor: "",
          move_in_parking: "",
          service_date: "",
          service_period: "",
          move_other_valuables: "",
          agency: "",
          msg:"",
          coupon_id:"",
          couponLocked:"",
          couponValue:0,
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:'',
          timeTable:{}
        },
        ifEditing:false
      }
    }
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedMove){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedMove;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "move"){
          localStorage.order = localStorage.savedMove;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
      }
    }
    if (localStorage.isEditing) {
      this.ifEditing = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  width: 85%;
  height: 118px;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 1.2em;
  margin: 0 auto;
  margin-top: 26px;
  padding-left:6vw;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.no-margin-top{
  margin-top:0;
}

.btn1{
  background: rgb(255,190,68);
  background:url('../../assets/img/joinus/recruitment.svg') center right no-repeat,linear-gradient(90deg, #F78A3A 0%,#FFC974 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(247,138,58,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(247,138,58,0.8);
  box-shadow: 0 10px 16px -10px rgba(247,138,58,0.8);
}

.btn2{
  background: rgb(255,128,154);
  background:url('../../assets/img/joinus/join.svg') center right no-repeat,linear-gradient(90deg, #9BB6FF 0%,#ABE0F9 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
}


.prepay-img{
  width:100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/service/joinus.vue